import React, { Component } from "react";
import UserCard from "../UserCard/UserCard";
import Fullscreen from 'fullscreen-react';



export class Scorm extends Component {

  // console.log(this.props.user.id);

  //const [isEnter, setIsEnter] = useState(false);


  constructor(props) {
    // console.log(props.sco);
    super();
    this.state = {
      sendAnswers: false,
      msg: "",
      isEnter: false
    };

  }

  componentDidMount() {

    window.API = new APIClass(this.props.user, this.props.setInitializeScorm, this.props.setCommitScorm, this.props.setFinishScorm);

  }

  


  render() {

    console.log("-----------------------");
    console.log(this.props.isEnter);

    return (
        <div className={"scorm_content " + (this.props.isEnter ? "fullscreen" : "not_fullscreen")}>
          <Fullscreen isEnter={this.props.isEnter} onChange={this.props.setIsEnter}>
          <div className={"embed-responsive card shadow-sm "+ (this.props.isEnter || window.screen.width <= 1000 ? "embed-responsive-16by9" : "embed-responsive-4by3")}>
            <iframe className="embed-responsive-item" allowFullScreen webkitallowfullscreen="true" mozallowfullscreen="true" src={"/lms/assets/scorm/" + this.props.course.scorm} scrolling="no" frameBorder="0" allow="geolocation; microphone; camera; encrypted-media; midi"></iframe>
          </div>
          </Fullscreen>
          <div className="both"></div>
          {/* {
            <div>
              <button
                className="btn btn-fullscreen"
                onClick={() => {
                  this.setIsEnter(true);
                }}
              >
                VER EM TELA CHEIA
              </button>
              <div className="both"></div>
            </div>
          } */}
        </div>
    );
  }
}


export default Scorm;

class APIClass {
  'use strict';
  //SCORM 1.2
  // this.LMSInitialize = LMSInitialize;
  // this.LMSFinish = LMSFinish;
  // this.LMSGetValue = LMSGetValue;
  // this.LMSSetValue = LMSSetValue;
  // this.LMSCommit = LMSCommit;
  // this.LMSGetLastError = LMSGetLastError;
  // this.LMSGetErrorString = LMSGetErrorString;
  // this.LMSGetDiagnostic = LMSGetDiagnostic;

  constructor(args, setInitializeScorm, setCommitScorm, setFinishScorm) {
    this.args = args;
    this.apiInitialized = false;
    this.apiLastError = '301';
    this.setInitializeScorm = setInitializeScorm;
    this.setCommitScorm = setCommitScorm;
    this.setFinishScorm = setFinishScorm;
    
    
  };


  LMSInitialize = (arg) => {
    'use strict';

    // console.log(this.args);
    
    console.log('*** LMSInitialize ***');

    if (arg != '') {
      this.apiLastError = '201';

      return 'false';
    }
    this.apiLastError = '0';
    this.apiInitialized = true;

    return 'true';
  }

  LMSFinish = (arg) => {

    'use strict';

    console.log('*** LMSFinish ***');

    

    if (this.apiInitialized) {

      if (arg != '') {
        this.apiLastError = '201';

        return 'false';
      }
      this.apiLastError = '0';
      this.apiInitialized = false;
      // Set value for 'cmi.core.entry' depending on 'cmi.core.exit'
      // if (scoData['cmi.core.exit'].toUpperCase() === 'SUSPEND') {
      //   scoData['cmi.core.entry'] = 'resume';
      // } else {
      //   scoData['cmi.core.entry'] = '';
      // }
      // commitResult('log');

      return 'true';
    } else {
      this.apiLastError = '301';   // not initialized

      return 'false';
    }
  }


  LMSGetValue = (arg) => {

    'use strict';

    console.log('*** LMSGetValue:: ' + arg + ' ***');

    if (this.apiInitialized) {

      switch (arg) {
        case 'cmi.core._children':
        case 'cmi.core.student_id':
        case 'cmi.core.student_name':
        case 'cmi.core.lesson_location':
        case 'cmi.core.credit':
        case 'cmi.core.lesson_status':
        case 'cmi.core.entry':
        case 'cmi.core.score._children':
        case 'cmi.core.score.raw':
        case 'cmi.core.score.min':
        case 'cmi.core.score.max':
        case 'cmi.core.total_time':
        case 'cmi.suspend_data':
        case 'cmi.launch_data':
        case 'cmi.core.lesson_mode':
        case 'cmi.student_data._children':
        case 'cmi.student_data.mastery_score':
        case 'cmi.student_data.max_time_allowed':
        case 'cmi.student_data.time_limit_action':
          this.apiLastError = '0';

        // return scoData[arg];
        case 'cmi.core.exit':
        case 'cmi.core.session_time':
          this.apiLastError = '404'; // write only

          return '';
        default:
          this.apiLastError = '401';

          return '';
      }
    } else {
      // not initialized error
      this.apiLastError = '301';

      return '';
    }
  }

  LMSSetValue = (argName, argValue) => {
// function LMSSetValue(argName, argValue) {
  'use strict';

  console.log('*** LMSSetValue:: [' + argName + '] = ' + argValue + ' ***');

  if (argName === "cmi.core.lesson_status" && (argValue === "passed" || argValue === "completed")){
    this.setFinishScorm();
  }

  if (this.apiInitialized) {

    switch (argName) {
      case 'cmi.core._children':
      case 'cmi.core.score._children':
      case 'cmi.student_data._children':
        this.apiLastError = '402'; // invalid set value, element is a keyword

        return 'false';
      case 'cmi.core.student_id':
      case 'cmi.core.student_name':
      case 'cmi.core.credit':
      case 'cmi.core.entry':
      case 'cmi.core.total_time':
      case 'cmi.launch_data':
      case 'cmi.core.lesson_mode':
      case 'cmi.student_data.mastery_score':
      case 'cmi.student_data.max_time_allowed':
      case 'cmi.student_data.time_limit_action':
        this.apiLastError = '403'; // read only

        return 'false';
      case 'cmi.core.lesson_location':

        if (argValue.length > 255) {
          this.apiLastError = '405';

          return 'false';
        }
        // scoData[argName] = argValue;
        this.apiLastError = '0';

        return 'true';
      case 'cmi.core.lesson_status':
        var upperCaseLessonStatus = argValue.toUpperCase();

        if (upperCaseLessonStatus !== 'PASSED' &&
          upperCaseLessonStatus !== 'FAILED' &&
          upperCaseLessonStatus !== 'COMPLETED' &&
          upperCaseLessonStatus !== 'INCOMPLETE' &&
          upperCaseLessonStatus !== 'BROWSED' &&
          upperCaseLessonStatus !== 'NOT ATTEMPTED') {

            this.apiLastError = '405';

          return 'false';
        }
        // scoData[argName] = argValue;
        this.apiLastError = '0';
        if (upperCaseLessonStatus == 'COMPLETED') {

        }
        return 'true';
      case 'cmi.core.score.raw':
      case 'cmi.core.score.min':
      case 'cmi.core.score.max':

        if (isNaN(parseInt(argValue)) || (argValue < 0) || (argValue > 100)) {
          this.apiLastError = '405';
          return 'false';
        }
        // scoData[argName] = argValue;
        this.apiLastError = '0';

        return 'true';
      case 'cmi.core.exit':
        var upperCaseExit = argValue.toUpperCase();

        if (upperCaseExit !== 'TIME-OUT' &&
          upperCaseExit !== 'SUSPEND' &&
          upperCaseExit !== 'LOGOUT' &&
          upperCaseExit !== '') {

            this.apiLastError = '405';

          return 'false';
        }
        // scoData[argName] = argValue;
        this.apiLastError = '0';

        return 'true';
      case 'cmi.core.session_time':
        // regex to check format
        // hhhh:mm:ss.ss
        var re = /^[0-9]{2,4}:[0-9]{2}:[0-9]{2}(.[0-9]{1,2})?$/;

        if (!re.test(argValue)) {
          this.apiLastError = '405';

          return 'false';
        }
        // check that minute and second are 0 <= x < 60
        var timeArray = argValue.split(':');

        if (timeArray[1] < 0 || timeArray[1] >= 60 || timeArray[2] < 0 || timeArray[2] >= 60) {
          this.apiLastError = '405';

          return 'false';
        }

        // scoData[argName] = argValue;
        this.apiLastError = '0';

        return 'true';
      case 'cmi.suspend_data':
        if (argValue.length > 4096) {
          this.apiLastError = '405';
          return 'false';
        }
        // scoData[argName] = argValue;
        this.apiLastError = '0';

        return 'true';
      default:
        this.apiLastError = '401';

        return 'false';
    }
  } else {
    // not initialized error
    this.apiLastError = '301';

    return 'false';
  }
}

LMSCommit = (arg) => {
  'use strict';

  
  console.log('*** LMSCommit ***');
  
  // this.setCommitScorm();
  // this.setFinishScorm();
  

  // if (this.apiInitialized) {
  //   if (arg != '') {
  //     this.apiLastError = '201';

  //     return 'false';
  //   } else {
  //     this.apiLastError = '0';
  //     // commitResult('persist');

  //     return 'true';
  //   }
  // } else {
  //   this.apiLastError = '301';

  //   return 'false';
  // }
    // return 'false';
}

LMSGetLastError = () => {

    'use strict';

    console.log('*** LMSGetLastError:: ' + this.apiLastError + ' ***');

    return this.apiLastError;
}

LMSGetErrorString = (errorCode) => {

    'use strict';

    console.log('*** LMSGetErrorString:: [' + errorCode + '] ***');

    switch (errorCode) {
        case '0' :
        case '101' :
        case '201' :
        case '202' :
        case '203' :
        case '301' :
        case '401' :
        case '402' :
        case '403' :
        case '404' :
        case '405' :

            // return errorString[errorCode];
        default :

            return 'Unknown Error';
    }
}


LMSGetDiagnostic = (errorCode) => {

  'use strict';

  var index = errorCode;

  if (index === '') {
    index = this.apiLastError;
  }
  console.log('*** LMSGetDiagnostic:: [' + index + '] ***');

  switch (index) {
    case '0':
    case '101':
    case '201':
    case '202':
    case '203':
    case '301':
    case '401':
    case '402':
    case '403':
    case '404':
    case '405':

    // return errorString[index];
    default:

      return 'Unknown Error';
  }
}
}




// WEBPACK FOOTER //
// ./src/components/Course/Scorm.jsx